<template>
    <Sidebar />
    <Content class="settings-content">
        <div class="inner">
            <Menu />
            <div class="col">
                <header class="head">
                    <h2>Custom invite card</h2>
                    <Button size="32" type="button" color="dark-blue">Save</Button>
                </header>
                <Scrollbar class="left">
                    <div class="custom-item">
                        <h3>Card background</h3>
                        <div class="color-item">
                            <label>Card color</label>
                            <span class="color-wrap">
                                <ColorPicker v-model:pureColor="bg_color" />
                            </span>
                            <span class="hex">#{{ bg_hex }}</span>
                            <span class="alpha"
                                v-if="bg_color.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i)[4]">{{
                                    (bg_color.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i)[4] *
                                        100).toFixed(0) }}%</span>
                            <span class="alpha" v-else>100%</span>
                        </div>
                        <div class="color-item">
                            <label>Header color</label>
                            <span class="color-wrap">
                                <ColorPicker v-model:pureColor="header_color" />
                            </span>
                            <span class="hex">#{{ header_hex }}</span>
                            <span class="alpha"
                                v-if="header_color.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i)[4]">{{
                                    (header_color.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i)[4] *
                                        100).toFixed(0) }}%</span>
                            <span class="alpha" v-else>100%</span>
                        </div>
                        <hr />
                        <div class="image-item">
                            <div class="label-item">
                                <label>Header Image</label>
                                <div class="flex">
                                    <div class="refresh">
                                        <div class="svg-box">
                                            <svg-icon name="refresh" />
                                        </div>
                                        Reset
                                    </div>
                                    <Switch :checked="header_is_switch" />
                                </div>
                            </div>
                            <div class="image-wrap" :class="{ 'no-image': !img }">
                                <img v-if="img" :src="img" />
                                <i v-if="!img"><svg-icon name="plus2" /></i>
                                <input type="file" ref="file" @change="loadImage($event)" accept="image/*">
                            </div>
                        </div>

                        <div class="drop-item">
                            <label>Placement</label>
                            <Dropdown :items="select_placement" @update-dropdown="updatePlacement" :default_value="1" />
                        </div>
                        <div class="drop-item">
                            <label>Size</label>
                            <Dropdown :items="select_placement" @update-dropdown="updatePlacement" :default_value="1" />
                        </div>
                        <div class="color-item">
                            <label>Opacity</label>
                            <span class="hex"></span>
                            <span class="alpha">100%</span>
                        </div>
                    </div>

                    <div class="custom-item">
                        <h3>Custom messages</h3>
                        <div class="textarea-item">
                            <div class="label-item">
                                <label>Sub text</label>
                                <div class="refresh">
                                    <div class="svg-box">
                                        <svg-icon name="refresh" />
                                    </div>
                                    <div class="text">Reset</div>
                                </div>
                            </div>
                            <textarea name="" id="" cols="30" rows="10"></textarea>
                        </div>
                    </div>
                </Scrollbar>
                <Scrollbar class="right">
                    <div class="preview">
                        <header>
                            <h3>Preview</h3>
                            <time>Updates May 20, 2023. 9.00pm EST. <svg-icon name="refresh" /></time>
                        </header>
                        <p>Welcoming card when creator joined</p>
                    </div>

                </Scrollbar>
            </div>
        </div>
    </Content>
    <Transition name="fade" v-show="is_show_cropper">
        <div class="cropper-wrap">
            <i @click="is_show_cropper = false"><svg-icon name="close" /></i>
            <div class="box">
                <cropper ref="cropper" :src="image.src" :debounce="false" />
                <Button size="40" color="dark-blue" @click.native="crop">Ok</Button>
            </div>

        </div>
    </Transition>
</template>

<script>
import Sidebar from '@/components/Sidebar.vue';
import Content from '@/components/ui/Content.vue';
import Button from '@/components/ui/Button.vue';
import Menu from '@/components/settings/Menu.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import Switch from '@/components/ui/Switch.vue';
import Dropdown from '@/components/ui/Dropdown.vue';
import { ColorPicker } from 'vue3-colorpicker';
import 'vue3-colorpicker/style.css';
import { Cropper } from 'vue-advanced-cropper';
import 'vue-advanced-cropper/dist/style.css';
export default {
    name: 'Settings',

    data() {
        return {
            sub_text: `Lets you collect, organize and share links with other people. You can get feedback on them as well.`,
            bg_color: 'rgba(255,255,255,1)',
            header_color: 'rgba(255,255,255,1)',
            is_show_cropper: false,
            img: '',
            img_blob: null,
            image: {
                src: null,
                type: null
            },
            header_is_switch: true,
            select_placement: [
                { text: 'pla-1', id: 1 }
            ]
        }
    },
    computed: {
        bg_hex() {
            let rgb = this.bg_color.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i),
                hex = rgb ?
                    (rgb[1] | 1 << 8).toString(16).slice(1) +
                    (rgb[2] | 1 << 8).toString(16).slice(1) +
                    (rgb[3] | 1 << 8).toString(16).slice(1) : this.bg_color;

            return hex;
        },

        header_hex() {
            let rgb = this.header_color.replace(/\s/g, '').match(/^rgba?\((\d+),(\d+),(\d+),?([^,\s)]+)?/i),
                hex = rgb ?
                    (rgb[1] | 1 << 8).toString(16).slice(1) +
                    (rgb[2] | 1 << 8).toString(16).slice(1) +
                    (rgb[3] | 1 << 8).toString(16).slice(1) : this.header_color;

            return hex;
        },
    },
    components: {
        Sidebar,
        Content,
        Button,
        Scrollbar,
        Menu,
        ColorPicker,
        Cropper,
        Switch,
        Dropdown,
    },

    // watch: {
    //     '$route.params': {
    //         handler(params) {
    //             this.selected_type = params.type;
    //             console.log(this.selected_type);
    //         },

    //         immediate: true,
    //     },
    // },

    methods: {
        crop() {
            const { canvas } = this.$refs.cropper.getResult();
            canvas.toBlob((blob) => {
                this.img_blob = blob;
                this.img = URL.createObjectURL(blob)
                this.is_show_cropper = false;

            }, this.image.type);
        },

        reset() {
            this.image = {
                src: null,
                type: null
            }
        },
        getMimeType(file, fallback = null) {
            const byteArray = (new Uint8Array(file)).subarray(0, 4);
            let header = '';

            for (let i = 0; i < byteArray.length; i++) {
                header += byteArray[i].toString(16);
            }
            switch (header) {
                case "89504e47":
                    return "image/png";
                case "47494638":
                    return "image/gif";
                case "ffd8ffe0":
                case "ffd8ffe1":
                case "ffd8ffe2":
                case "ffd8ffe3":
                case "ffd8ffe8":
                    return "image/jpeg";
                default:
                    return fallback;
            }
        },

        loadImage(event) {
            // Reference to the DOM input element
            const { files } = event.target;
            const self = this;
            // Ensure that you have a file before attempting to read it
            if (files && files[0]) {
                // 1. Revoke the object URL, to allow the garbage collector to destroy the uploaded before file
                if (this.image.src) {
                    URL.revokeObjectURL(this.image.src)
                }
                // 2. Create the blob link to the file to optimize performance:
                const blob = URL.createObjectURL(files[0]);

                // Create a new FileReader to read this image binary data
                const reader = new FileReader();
                reader.onload = (e) => {
                    this.image = {
                        src: blob,
                        type: self.getMimeType(e.target.result, files[0].type),
                    };
                };
                reader.readAsArrayBuffer(files[0]);

                this.is_show_cropper = true;
            }
        },
        updatePlacement() {

        }
    },

    destroyed() {
        if (this.image.src) {
            URL.revokeObjectURL(this.image.src)
        }
    },

    mounted() {

    },
}
</script>

<style lang="scss">
@mixin flex_center {
    display: flex;
    align-items: center;
}

.page-setting-custom,
.page-setting-storefront {
    .settings-content {
        .inner {
            height: 100%;
            padding: 32px 48px;
            display: flex;
        }

        .col {
            flex: 1;
            box-sizing: border-box;
            padding: 12px 0 0 32px;
            margin-left: 32px;
            border-left: 1px solid var(--black-20);
            display: flex;
            flex-wrap: wrap;
            max-width: 1200px;
        }

        .head {
            display: flex;
            align-items: center;
            width: 100%;
            height: 66px;
            padding-bottom: 6px;

            h2 {
                flex: 1;
                font-family: var(--font-dm);
                font-size: 40px;
                font-weight: 400;
            }
        }

        .scrollbar-content {
            height: calc(100% - 72px);

            &.left {
                margin-right: 12px;
                width: calc(40% - 12px);
            }

            &.right {
                margin-left: 12px;
                width: calc(60% - 12px);
                background-color: var(--bg-10);
            }
        }

        .preview {
            padding: 24px;

            &>header {
                padding-bottom: 12px;
                display: flex;
                align-items: center;

                h3 {
                    flex: 1;
                    color: var(--black-90);
                    font: var(--font-fg-20);
                }

                time {
                    display: flex;
                    align-items: center;
                    font-size: 12px;
                    color: var(--black-60);

                    svg {
                        display: block;
                        height: 12px;
                        width: 12px;
                        margin-left: 8px;
                        fill: var(--black-60);
                    }
                }
            }

            &>p {
                color: var(--black-90);
                font: var(--font-16);
                margin: 0 0 16px;
            }
        }

        .custom-item {
            padding: 12px;
            border-radius: 8px;
            margin-bottom: 16px;
            border: 1px solid var(--black-10);

            h3 {
                font: var(--font-fg-16);
            }

            hr {
                margin: 12px -12px;
                height: 1px;
                border: none;
                overflow: hidden;
                background-color: var(--black-10);
                display: block;
            }
        }

        @mixin label_box {
            display: flex;
            align-items: center;
            width: 100%;
            font-size: 12px;
            margin: 12px 0;
        }

        @mixin input_border {
            border-radius: 6px;
            border: solid 1px var(--black-40);
        }

        .color-item {
            @include label_box;

            label {
                flex: 1;
            }

            .hex {
                padding: 0 12px;
                border-right: 1px solid var(--black-10);
                margin-right: 12px;
                width: 70px;
                text-transform: uppercase;
            }

            .alpha {
                width: 40px;
                text-align: center;
            }

            .color-wrap {
                background-image: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAIAAADZF8uwAAAAGUlEQVQYV2M4gwH+YwCGIasIUwhT25BVBADtzYNYrHvv4gAAAABJRU5ErkJggg==);
                background-repeat: repeat;
                height: 24px;
                width: 24px;
                cursor: pointer;
                position: relative;
                overflow: hidden;


                &::before {
                    pointer-events: none;
                    position: absolute;
                    left: 0;
                    top: 0;
                    height: 100%;
                    width: 100%;
                    content: '';
                    z-index: 9;
                    box-sizing: border-box;
                    border: 1px solid rgba(#000, .1);
                }
            }
        }

        .drop-item {
            @include label_box;
            justify-content: space-between;

            .ui-button.type-border-square {
                box-sizing: border-box;
                width: 154px;
                height: 32px;
                @include input_border;
                justify-content: space-between;
                flex-direction: row-reverse;
            }

            .ui-dropdown--inner .item-box {
                width: 154px;
            }
        }

        .label-item {
            @include label_box;
            justify-content: space-between;
        }

        .textarea-item {
            textarea {
                width: 100%;
                @include input_border;
            }
        }

        .refresh {
            color: var(--black-50);
            @include flex_center;
            cursor: pointer;

            .text {
                padding: 0 4px;
            }

            .svg-box {
                width: 16px;
                height: 16px;
                @include flex_center;
                justify-content: center;

            }

            svg {
                width: 10px;
                height: 10px;
            }
        }

        .ui-switch {
            margin-left: 6px
        }

        .flex {
            @include flex_center;
        }
    }

    .image-wrap {
        width: 100%;
        position: relative;
        background-color: var(--black-10);
        cursor: pointer;
        margin: 12px 0 0;

        &.no-image {
            height: 220px;
        }

        img {
            width: 100%;
            display: block;
        }

        i {
            height: 22px;
            width: 22px;
            position: absolute;
            z-index: 1;
            left: 50%;
            top: 50%;
            margin: -11px 0 0 -11px;

            svg {
                height: 100%;
                width: 100%;
                display: block;
                fill: var(--black-50);
            }
        }

        input {
            position: absolute;
            height: 100%;
            width: 100%;
            left: 0;
            opacity: 0;
            top: 0;
            z-index: 3;
            cursor: pointer;
        }
    }

    .cropper-wrap {
        position: fixed;
        z-index: 999;
        height: 100%;
        left: 0;
        top: 0;
        width: 100%;
        background-color: rgba(#fff, .5);
        backdrop-filter: blur(5px);

        i {
            cursor: pointer;
            height: 42px;
            width: 42px;
            position: absolute;
            z-index: 3;
            right: 24px;
            top: 24px;

            svg {
                display: block;
                height: 100%;
                width: 100%;
                fill: var(--dark-blue);
            }
        }

        .box {
            width: 560px;
            position: absolute;
            left: 50%;
            top: 50%;
            margin: -280px 0 0 -280px;

            .ui-button {
                width: 80px;
                display: block;
                text-align: center;
                margin: 12px auto 0;
            }
        }
    }
}
</style>